import BigNumber from "bignumber.js";
import { PropsWithClassName, cn, fAmount } from "kz-ui-sdk";
import { useMemo } from "react";
import styles from "./PrizeAmount.module.css";

interface PrizeAmountProps extends PropsWithClassName {
  amount: number | BigNumber | undefined;
  locked?: boolean;
  shiny?: boolean;
  fontSize?: string | number;
}

const getLockedText = (text: string): string => {
  const isDigit = (char: string) => /\d/.test(char);
  let digitIndex = 0;

  return text
    .split("")
    .map((char) => {
      if (!isDigit(char)) {
        return char;
      }

      let replacement = "$";
      if (digitIndex >= 2 && digitIndex % 2 === 0) {
        replacement = char;
      }

      digitIndex++;
      return replacement;
    })
    .join("");
};

const PrizeAmount = ({ className, amount, locked = false, shiny = true, fontSize }: PrizeAmountProps) => {
  const displayText = useMemo(() => {
    const amountText = fAmount(amount, {
      abbreviate: true,
      noGrouping: locked,
    });

    return locked ? getLockedText(amountText) : amountText;
  }, [locked, amount]);

  return (
    <span
      className={cn(styles.prizeAmount, [shiny && styles.prizeAmountAnimated], "inline-block", className)}
      style={{ fontSize }}
      data-text={displayText}
    >
      {displayText}
    </span>
  );
};

export default PrizeAmount;
